import React from "react";
// React Table
import { Container, Table, Row, Col } from "react-bootstrap";
// Styled Components
import styled from "styled-components";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaCanonicos = ({ datosComunidad }) => {
  return (
    <Table bordered responsive>
      <tbody>
        <tr>
          <CustomTd className={"w-50"}>
            <span>Número de Registro Ministerial</span>
          </CustomTd>
          <td>{datosComunidad?.departmentNumber || <small>No especificado</small>}</td>
        </tr>
        <tr>
          <CustomTd>
            <span>Número de Identificación Fiscal</span>
          </CustomTd>
          <td>{datosComunidad?.fiscalNumber || <small>No especificado</small>}</td>
        </tr>
        <tr>
          <CustomTd>
            <span>Teléfono</span>
          </CustomTd>
          <td>{datosComunidad?.telephone || <small>No especificado</small>}</td>
        </tr>
        <tr>
          <CustomTd>
            <span>Email</span>
          </CustomTd>
          <td>{datosComunidad?.email || <small>No especificado</small>}</td>
        </tr>
        <tr>
          <CustomTd>
            <span>Contexto</span>
          </CustomTd>
          <td>{datosComunidad?.context || <small>No especificado</small>}</td>
        </tr>
        <tr>
          <CustomTd>
            <span>Dirección</span>
          </CustomTd>
          <td>{datosComunidad?.address || <small>No especificado</small>}</td>
        </tr>
        <tr>
          <CustomTd>
            <span>Ciudad</span>
          </CustomTd>
          <td>{datosComunidad?.city || <small>No especificado</small>}</td>
        </tr>
        <tr>
          <CustomTd>
            <span>CP</span>
          </CustomTd>
          <td>{datosComunidad?.postcode || <small>No especificado</small>}</td>
        </tr>
        <tr>
          <CustomTd>
            <span>País</span>
          </CustomTd>
          <td>{datosComunidad?.country || <small>No especificado</small>}</td>
        </tr>
      </tbody>
    </Table>
  );
};

export default VistaCanonicos;
